import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { ArrowLeft } from "lucide-react";
import ConversationsList from "@/components/messaging/ConversationsList";
import ChatView from "@/components/messaging/ChatView";

export default function Messages() {
  const { applicationId: convRef } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) navigate("/login", { replace: true });
  }, [user, loading, navigate]);

  if (!user) return null;

  return (
    <div data-testid="messages-page" className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate("/dashboard")} data-testid="messages-logo-link" aria-label="Retour au tableau de bord">
            <Logo />
          </button>
          <button
            data-testid="messages-back-button"
            onClick={() => (convRef ? navigate("/messages") : navigate("/dashboard"))}
            className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-brand-navy border border-slate-300 rounded-lg px-4 py-2 hover:bg-slate-100 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {convRef ? "Conversations" : "Retour"}
          </button>
        </div>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-6 py-8 flex flex-col">
        {convRef ? <ChatView convRef={convRef} /> : <ConversationsList />}
      </main>
    </div>
  );
}
